import type { FC } from "react";
import styled from "styled-components";
import type { LinkItem } from "src/http/api-types";
import { TeamCard } from "../TeamCard";

const StyledTeamsNearYouList = styled.div`
  display: grid;
  gap: 16px;
  grid-auto-flow: column;
  grid-auto-columns: minmax(250px, 1fr);
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  height: auto;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
`;

interface Props {
  onClick: (() => void) | undefined;
  teams: LinkItem[];
}

/**
 * Teams Near You Mobile UI (Horizontal Scrolling Container)
 */
export const TeamsNearYouList: FC<Props> = ({ onClick, teams }) => (
  <StyledTeamsNearYouList>
    {teams.map((team) => (
      <TeamCard key={team.id} onClick={onClick} {...team} />
    ))}
  </StyledTeamsNearYouList>
);
